import React from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { Panel } from '../components/Panel';
import { WatchList } from '../components/WatchList';
import { alwaysOn, productRotation } from '../data/plan';
import { pillarStyles } from '../utils/stats';
export function Products() {
  const maxAnchors = Math.max(...productRotation.map(p => p.anchors));
  return <div data-id="element-274" data-mp="2s45ze82franm">
      <PageHeader eyebrow="Rotation & watch items" title="Products & risk" description="Who gets airtime, on which standing slot, and what still needs a decision before its reserved slots can ship." data-id="element-275" data-mp="2s60mnt16jeuv" />

      <div className="grid gap-4 xl:grid-cols-3" data-id="element-276" data-mp="32127wdsc3ws6">
        <Panel eyebrow="Anchor coverage" title="Product rotation" className="xl:col-span-2" bodyClassName="px-0 py-0" data-id="element-277" data-mp="2x3sll708s18k">
          <ul className="divide-y divide-ink-700/70" data-id="element-278" data-mp="hbl6puvkvkbq">
            {productRotation.map((p, i) => <li key={p.product} className="grid gap-2 px-5 py-3.5 sm:grid-cols-[minmax(0,180px)_minmax(0,1fr)_88px] sm:items-center" data-id="element-279" data-mp="cd1l5vkwcajw" data-mpi={i}>
                <span className="text-[13px] font-medium text-chalk" data-id="element-280" data-mp="1iaxqm9tpeliu">{p.product}</span>
                <span className="text-xs leading-relaxed text-mute" data-id="element-281" data-mp="1n9r80dc42woa">{p.standingSlot}</span>
                <span className="flex items-center gap-2" data-id="element-282" data-mp="1s7iwexdjs0nq">
                  <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-ink-800" data-id="element-283" data-mp="1w8melqj2i8s4">
                    <motion.span initial={{
                  width: 0
                }} animate={{
                  width: `${p.anchors / maxAnchors * 100}%`
                }} transition={{
                  duration: 0.6,
                  delay: i * 0.03,
                  ease: [0.22, 1, 0.36, 1]
                }} className="block h-full rounded-full bg-evergreen/80" data-id="element-284" data-mp="zilpfqesdqaa" />
                  </span>
                  <span className="w-5 text-right font-mono text-[11px] text-mute" data-id="element-285" data-mp="grkiaf3iiofn">{p.anchors}</span>
                </span>
              </li>)}
          </ul>
        </Panel>

        <Panel eyebrow="Read before working the calendar" title="Assumptions & flags" data-id="element-286" data-mp="kqtctm6dmqc9">
          <WatchList data-id="element-287" data-mp="1o20gffkpjbgv" />
        </Panel>
      </div>

      <Panel eyebrow="168 recurring slots" title="Always-on slate" className="mt-4" bodyClassName="px-0 py-0" data-id="element-288" data-mp="1j5s6cglda8gk">
        <div className="overflow-x-auto" data-id="element-289" data-mp="1xvzea2dr0930">
          <table className="w-full min-w-[720px] text-left" data-id="element-290" data-mp="1sua4sr66c3h1">
            <thead data-id="element-291" data-mp="1sx60e8ujug2b">
              <tr className="border-b border-ink-700/70 font-mono text-[10px] uppercase tracking-[0.14em] text-faint" data-id="element-292" data-mp="154z8pmzrqx98">
                <th scope="col" className="px-5 py-3 font-normal" data-id="element-293" data-mp="106xrl7lwl80e">Slot</th>
                <th scope="col" className="px-5 py-3 font-normal" data-id="element-294" data-mp="1e5xcc46ap2ra">Channels</th>
                <th scope="col" className="px-5 py-3 font-normal" data-id="element-295" data-mp="1e3t4jb59zjlq">Pillar</th>
                <th scope="col" className="px-5 py-3 font-normal" data-id="element-296" data-mp="1a2r2ynnvyvgl">Cadence</th>
                <th scope="col" className="px-5 py-3 text-right font-normal" data-id="element-297" data-mp="2pk1almjx1d25">Slots</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-ink-700/70" data-id="element-298" data-mp="2lj7jylf39k5k">
              {alwaysOn.map(row => <tr key={row.slot} className="transition-colors hover:bg-ink-800/50" data-id="element-299" data-mp="2t1ow6zecnd28">
                  <td className="px-5 py-3 text-[13px] text-chalk" data-id="element-300" data-mp="2y3o1wfxkam2c">{row.slot}</td>
                  <td className="px-5 py-3 font-mono text-[11px] text-mute" data-id="element-301" data-mp="2j5vmrovxfzoo">{row.channels}</td>
                  <td className="px-5 py-3" data-id="element-302" data-mp="2o4yigiq0otjz">
                    <span className={`inline-flex rounded-full border px-2 py-0.5 font-mono text-[9px] uppercase tracking-[0.14em] ${pillarStyles[row.pillar].border} ${pillarStyles[row.pillar].bg} ${pillarStyles[row.pillar].text}`} data-id="element-303" data-mp="2o5zw8uyf3u5e">
                      {row.pillar}
                    </span>
                  </td>
                  <td className="px-5 py-3 font-mono text-[11px] text-mute" data-id="element-304" data-mp="372rk7howmxfs">{row.cadence}</td>
                  <td className="px-5 py-3 text-right font-display text-lg text-chalk" data-id="element-305" data-mp="3usc6a9gcuata">{row.total}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <p className="border-t border-ink-700/70 px-5 py-3 text-xs leading-relaxed text-mute" data-id="element-306" data-mp="3fr6hl6hek86">
          These are not filler — they are the layer that earns the right to run six campaigns at once.
        </p>
      </Panel>
    </div>;
}